import { useRouteMatch } from "react-router-dom";

import { RELATIVE_PATHS, ROUTES } from "@/routes_new";

export function searchSectionRoutes(detailPath: string) {
  const reach = `${detailPath}${RELATIVE_PATHS.ALERT_INSIGHTS_REACH}`;
  const sentiment = `${detailPath}${RELATIVE_PATHS.ALERT_INSIGHTS_SENTIMENT}`;
  const results = `${detailPath}${RELATIVE_PATHS.ALERT_INSIGHTS_RESULTS}`;
  const period = ":startDate/:endDate";

  return {
    detail: detailPath,
    detailPeriod: `${detailPath}${RELATIVE_PATHS.MENTIONS_PERIOD}`,
    insightsReach: `${reach}/`,
    insightsSentiment: `${sentiment}/`,
    insightsResults: `${results}/`,
    insightsReachPeriod: `${reach}/${period}`,
    insightsSentimentPeriod: `${sentiment}/${period}`,
    insightsResultsPeriod: `${results}/${period}`,
  };
}

export function useSearchSectionRoutes() {
  const isArchive = Boolean(useRouteMatch(ROUTES.ARCHIVE_DETAIL_ORGID));
  const isSavedSearch = Boolean(
    useRouteMatch(ROUTES.SAVED_SEARCHES_DETAIL_ORGID)
  );

  if (isArchive) {
    return searchSectionRoutes(ROUTES.ARCHIVE_DETAIL_ORGID);
  }

  if (isSavedSearch) {
    return searchSectionRoutes(ROUTES.SAVED_SEARCHES_DETAIL_ORGID);
  }

  return searchSectionRoutes(ROUTES.MENTION_DETAIL_ORGID);
}
